<mat-sidenav-container>
    <mat-sidenav
        #sidenav
        role="navigation"
        [mode]="mobileQuery.matches ? 'over' : 'side'"
        [opened]="mobileQuery.matches ? 'false' : 'true'"
        class="mat-elevation-z2">
        <app-main-nav (sidenavClose)="toggleSidenav(sidenav)"></app-main-nav>
    </mat-sidenav>
    <mat-sidenav-content>
        <app-main-header (sidenavToggle)="toggleSidenav(sidenav, true)"></app-main-header>
        <main [ngClass]="{hidden: !isValidBrowser}">
            <router-outlet></router-outlet>
        </main>
        <main *ngIf="!isValidBrowser">
            <app-unsupported-browser (hide)="hideInvalidBrowser()"></app-unsupported-browser>
        </main>
    </mat-sidenav-content>
</mat-sidenav-container>
<div class="loading" *ngIf="isRouteLoading || isTranslationLoading">
    <mat-progress-bar class="progress-bar" mode="indeterminate"></mat-progress-bar>
</div>
